import { faClockRotateLeft, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, IconButton, Popover, Typography } from '@vapor/material'
import { FormItem } from 'hic-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import BaseCustomerLookup, { BaseCustomerLookup as BaseCustomerLookupType } from '../../customer-lookup/base/base-customer-lookup'
import HistoricalCustomerResearchGrid from './historical-customer-research.grid'
import { SimpleCustomerLookupFragment, SimpleCustomersLookupDocument } from 'src/api/api.generated'
import { SimpleCustomerLookupOption } from '../../customer-lookup/option/simple-customer-lookup-option'

type HistoricalCustomerResearchProps = {
  disabled?: boolean
  tenantId: string
  propertyId: string
}

export default function HistoricalCustomerResearch({ disabled, propertyId, tenantId }: HistoricalCustomerResearchProps) {
  const { t } = useTranslation()
  const [searchCustomer, setSearchCustomer] = useState<BaseCustomerLookupType | null>(null)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const closePopover = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  return (
    <>
      {searchCustomer === null && (
        <Button variant="text" size="small" disabled={disabled} startIcon={<FontAwesomeIcon icon={faClockRotateLeft} />} onClick={openPopover}>
          {t('pms.booking.reservation_new.historical_customer_research.title')}
        </Button>
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box p={1}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} minWidth={'340px'}>
            <Box>
              <FontAwesomeIcon icon={faClockRotateLeft} />
              <Typography variant="body700" marginLeft={0.5}>
                {t('pms.booking.reservation_new.historical_customer_research.title')}
              </Typography>
            </Box>
            <IconButton size="small" onClick={closePopover}>
              <FontAwesomeIcon icon={faXmark} />
            </IconButton>
          </Box>
          <Box marginTop={1}>
            <FormItem fullWidth fieldLabel={t('pms.booking.reservation_new.historical_customer_research.customer')}>
              <BaseCustomerLookup<SimpleCustomerLookupFragment>
                size="small"
                disabled={disabled}
                queryDocument={SimpleCustomersLookupDocument}
                value={searchCustomer}
                onChange={(value) => {
                  setSearchCustomer(value)
                  if (value?.id) {
                    closePopover()
                  }
                }}
                minSearchParameterLenght={2}
                renderOption={(option) => <SimpleCustomerLookupOption option={option} showEmail={true} showPhoneNumber={true} showTags={true} showRelatedCompany={true} />}
                noOptionsText={<i>{t('pms.components.customer_lookup.name_input_tip')}</i>}
              />
            </FormItem>
          </Box>
        </Box>
      </Popover>
      {searchCustomer !== null && (
        <Box
          sx={{
            p: { xs: 0.5, sm: 1 },
            backgroundColor: 'var(--AzureishWhite)',
          }}
        >
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Box>
              <FontAwesomeIcon icon={faClockRotateLeft} />
              <Typography variant="body700" marginLeft={0.5}>
                {t('pms.booking.reservation_new.historical_customer_research.title')}
              </Typography>
            </Box>
            <IconButton size="small" onClick={() => setSearchCustomer(null)}>
              <FontAwesomeIcon icon={faXmark} />
            </IconButton>
          </Box>
          <HistoricalCustomerResearchGrid propertyId={propertyId} tenantId={tenantId} initialCustomer={searchCustomer} />
        </Box>
      )}
    </>
  )
}
